import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-703e6dca")

_pushScopeId("data-v-703e6dca")
const _hoisted_1 = { class: "radio-input" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("input", {
      type: "radio",
      id: _ctx.item,
      value: _ctx.item,
      name: _ctx.name,
      checked: _ctx.checked
    }, null, 8, ["id", "value", "name", "checked"]),
    _createVNode("label", {
      class: "radio-input-wrap",
      for: _ctx.item,
      tabindex: "0"
    }, _toDisplayString(_ctx.label || _ctx.item), 9, ["for"])
  ]))
})